import "@fontsource-variable/newsreader/wght.css";
import "@fontsource-variable/newsreader/wght-italic.css";
import "@fontsource/ibm-plex-mono/latin-400.css";
import "@fontsource/ibm-plex-mono/latin-500.css";
import "@fontsource/ibm-plex-mono/latin-600.css";
import "lenis/dist/lenis.css";
import { lazy, StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { I18nProvider } from "./i18n";
import "./styles.css";

const showDetailPreview =
  import.meta.env.DEV &&
  new URLSearchParams(window.location.search).get("preview") === "detail";

// The development-only detail preview mounts the detail overlay directly. It
// stays behind a dynamic import so it never anchors that overlay into the
// production entry chunk.
const DetailPreview = showDetailPreview
  ? lazy(() =>
      import("./components/DetailPreview").then((module) => ({
        default: module.DetailPreview
      }))
    )
  : null;

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <I18nProvider>
      <Suspense fallback={null}>
        {DetailPreview ? <DetailPreview /> : <App />}
      </Suspense>
    </I18nProvider>
  </StrictMode>
);
